import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
import { useConfirm } from './use-confirm';
export const Confirm = ({ onConfirm, onDecline, children, ...props }) => {
    const [Confirm, handler] = useConfirm(onConfirm, onDecline);
    return (_jsxs(Fragment, { children: [children(handler), _jsx(Confirm, { ...props })] }));
};
//# sourceMappingURL=confirm.js.map